<template>
    <div id="Header">
        <div class="header-logo">
            <img src="../../assets/SupsisAiLogo.png" />
        </div>
        <div class="header-content">
            <div class="circle-and-line">
                <div
                    :class="['circle', completedPages.pageOne ? 'page-border' : 'bg-default', isActive('pageTwo') ? 'active' : '']">
                    <CheckWhite v-if="completedPages.pageOne" />
                </div>
                <div :class="['line', completedPages.pageTwo ? 'active' : '']"></div>
                <div
                    :class="['circle', completedPages.pageTwo ? 'page-border' : 'bg-default', isActive('pageThree') ? 'active' : '']">
                    <CheckWhite v-if="completedPages.pageTwo" />
                </div>
                <div :class="['line', completedPages.pageThree ? 'active' : '']"></div>
                <div
                    :class="['circle', completedPages.pageThree ? 'page-border' : 'bg-default', isActive('pageFour') ? 'active' : '']">
                    <CheckWhite v-if="completedPages.pageThree" />
                </div>
                <div :class="['line', completedPages.pageFour ? 'active' : '']"></div>
                <div
                    :class="['circle', completedPages.pageFour ? 'page-border' : 'bg-default', isActive('pageFive') ? 'active' : '']">
                    <CheckWhite v-if="completedPages.pageFour" />
                </div>
                <div :class="['line', completedPages.pageFive ? 'active' : '']"></div>
                <div
                    :class="['circle', completedPages.pageFive ? 'page-border' : 'bg-default', isActive('pageFive') ? 'active' : '']">
                    <CheckWhite v-if="completedPages.pageFive" />
                </div>
            </div>
            <div class="text-container">
                <div class="text">{{ $t("loginInformation") }}</div>
                <div class="text">{{ $t("whatIsYourPurpose") }}</div>
                <div class="text">{{ $t("addingASystem") }}</div>
                <div class="text">{{ $t("addingAModule") }}</div>
                <div class="text">{{ $t("letsGetToKnowYou") }}</div>
            </div>
        </div>
        <div>
        </div>
    </div>
</template>

<script>
import CheckWhite from "../icon/CheckWhite.vue";
import { loadFromLocalStorage, saveToLocalStorage } from '../../utils/formStore';

export default {
    name: "HeaderItem",
    props: {
        currentPage: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            completedPages: Object.assign({
                pageOne: false,
                pageTwo: false,
                pageThree: false,
                pageFour: false,
                pageFive: false,
            }, loadFromLocalStorage().completedPages)
        };
    },
    watch: {
        currentPage(newPage) {
            console.log(`Page changed to: ${newPage}`);
            this.updateCompletedPages();
        },
    },
    methods: {
        updateCompletedPages() {
            const pagesOrder = ['pageOne', 'pageTwo', 'pageThree', 'pageFour', 'pageFive'];
            const currentIndex = pagesOrder.indexOf(this.currentPage);

            pagesOrder.forEach((page, index) => {
                this.completedPages[page] = index <= currentIndex;
            });

            saveToLocalStorage({ completedPages: this.completedPages });
        },
        isActive(nextPage) {
            const pages = ["pageOne", "pageTwo", "pageThree", "pageFour", "pageFive"];
            return pages.indexOf(this.currentPage) >= pages.indexOf(nextPage);
        },
    },
    components: {
        CheckWhite,
    },
    mounted() {
        this.updateCompletedPages();
    },
};
</script>

<style lang="scss">
#Header {
    background-color: #ffff;
    display: flex;
    padding: 20px;
    justify-content: space-between;
    align-items: center;

    .header-logo {
        img {
            width: 200px;
        }
    }

    .header-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-left: -150px;

        .circle-and-line {
            display: flex;
            align-items: center;
            position: relative;

            .bg-default {
                border: 3px solid #ECD1CB !important;
            }

            .page-border {
                border: 3px solid #e75a4d !important;
            }

            .circle {
                width: 30px;
                height: 30px;
                border: 3px solid #e75a4d;
                border-radius: 50%;
                background-color: #fff;
                z-index: 1;
                display: grid;
                justify-content: center;
                align-content: center;

                &.active {
                    background-color: #e75a4d;
                    border: 3px solid #e75a4d;
                }
            }

            .line {
                width: 110px;
                height: 2px;
                background-color: #ECD1CB;

                &.active {
                    background-color: #e75a4d;
                }
            }
        }

        .text-container {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            width: 100%;
            gap: 5px;
        }

        .text {
            font-size: 14px;
            color: #262a50;
            text-align: center;
            width: 120px;
            min-width: 120px;
            white-space: normal;
            line-height: 1.2;
            padding: 0 2px;
            overflow-wrap: break-word;
        }
    }

    @media screen and (max-width: 1050px) {
        .header-content {
            margin-left: -80px;
            
            .circle-and-line {
                .line {
                    width: 95px;
                }
                
                .circle {
                    width: 28px;
                    height: 28px;
                }
            }
            
            .text-container {
                gap: 8px;
                
                .text {
                    width: 100px;
                    min-width: 100px;
                    font-size: 13px;
                }
            }
        }
    }

    @media screen and (max-width: 1024px) {
        .header-content {
            margin-left: -50px;
            
            .circle-and-line {
                .line {
                    width: 80px;
                }
            }
            
            .text-container {
                gap: 6px;
                
                .text {
                    font-size: 14px;
                }
            }
        }
    }

    @media screen and (max-width: 900px) {
        .header-content {
            margin-left: -30px;
            
            .circle-and-line {
                .line {
                    width: 60px;
                }
                
                .circle {
                    width: 25px;
                    height: 25px;
                }
            }
            
            .text-container {
                gap: 4px;
                
                .text {
                    width: 90px;
                    min-width: 90px;
                    font-size: 12px;
                }
            }
        }
    }

    @media screen and (max-width: 768px) {
        flex-direction: column;
        padding: 10px;
        
        .header-logo {
            margin-bottom: 15px;
            img {
                width: 150px;
            }
        }

        .header-content {
            margin-left: 0;
            width: 100%;
            
            .circle-and-line {
                width: 100%;
                justify-content: center;
                
                .circle {
                    width: 20px;
                    height: 20px;
                }

                .line {
                    width: 40px;
                }
            }

            .text-container {
                gap: 3px;
                flex-wrap: nowrap;
                
                .text {
                    width: 80px;
                    min-width: 80px;
                    font-size: 11px;
                }
            }
        }
    }

    @media screen and (max-width: 480px) {
        .header-content {
            .circle-and-line {
                .line {
                    width: 25px;
                }
            }
            
            .text-container {
                .text {
                    width: 70px;
                    min-width: 70px;
                    font-size: 10px;
                }
            }
        }
    }

    @media screen and (max-width: 360px) {
        .header-content {
            .circle-and-line {
                .line {
                    width: 20px;
                }
                
                .circle {
                    width: 18px;
                    height: 18px;
                }
            }
            
            .text-container {
                .text {
                    width: 60px;
                    min-width: 60px;
                    font-size: 9px;
                }
            }
        }
    }
}
</style>